export default "<h2 class=\"form__section--heading-success\"><%= title %></h2>\n<p><%= message %></p>\n"